import { defineStore } from "pinia";

export const useEditStore = defineStore("editStore", {
  state: () => ({
    isEditMode: false,
    editFormId: null,
    isCloneMode: false,
  }),
  actions: {
    setIsEditMode() {
      this.isEditMode = true;
    },
    setEditFormId(editId) {
      this.editFormId = editId;
    },
    setIsCloneMode(isClone) {
      this.isCloneMode = isClone;
    },
    closeEditMode() {
      this.isEditMode = false;
      this.editFormId = null;
      this.isCloneMode = false;
    },
  },
});
